<template>
  <div class="settings-container">
    <div class="card" :class="{ active: selectedOption || showSalesTarget }">
      <ul class="list">
<!--        <li-->
<!--            v-for="(item, index) in options2"-->
<!--            :key="index"-->
<!--            class="item"-->
<!--            @click="selectOptionAndHideSalesTarget(item)"-->
<!--        >-->
<!--          <span class="label">{{ item.label }}</span>-->
<!--          <component :is="item.icon" class="icon" />-->
<!--        </li>-->
        <li
            @click="showRequestTypes"
            class="item"
            v-if="isManager === true"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-list"/>
          <span class="label">Request Types</span>
        </li>
        <li
            @click="showSubTypes"
            class="item"
            v-if="isManager === true"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-credit-card"/>
          <span class="label">Sub Types</span>
        </li>
        <li
            @click="showSessionSetup"
            class="item"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-sliders"/>
          <span class="label">Session Setup</span>
        </li>
      </ul>
    </div>

    <div class="content" v-if="requestsTypes">
      <h2>Request Types</h2>
      <div style="display: flex;">
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Add Request Type"
            @click="showModal"
        />
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Close"
            buttonColor="black"
            hoverColor="#c82333"
            hoverTextColor="#ffffff"
            @click="closeContent"
        />
      </div>
      <div
          class="role-card"
          v-for="(role, index) in allRequestTypes"
          :key="role.id"
          @click="updateModal(role)"
      >
        <p class="p-tag">{{ role.name }}</p>
      </div>
<!--      <button @click="closeContent" class="close-btn mt-3">Close</button>-->
    </div>

    <div class="content" v-if="subTypes">
      <h2>Create Sub Types</h2>
      <div style="display: flex;">
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Add Sub Type"
            @click="SubTypeModal"
        />
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Close"
            buttonColor="black"
            hoverColor="#c82333"
            hoverTextColor="#ffffff"
            @click="closeContent"
        />
      </div>
      <div
          class="role-card"
          v-for="(role, index) in allRequestTypes"
          :key="role.id"
          @click="viewSubType(role)"
      >
        <p class="p-tag">{{ role.name }}</p>
      </div>
      <!--      <button @click="closeContent" class="close-btn mt-3">Close</button>-->
    </div>

    <div class="content" v-if="sessionSetup">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <h2>Session Settings</h2>
<!--        <ApproveButton-->
<!--            style="margin-top: 30px"-->
<!--            buttonText="Add Sub Type"-->
<!--            @click="SubTypeModal"-->
<!--        />-->
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Close"
            buttonColor="black"
            hoverColor="#c82333"
            hoverTextColor="#ffffff"
            @click="closeContent"
        />
      </div>
      <div>
        <SessionSetup/>
      </div>
      <!--      <button @click="closeContent" class="close-btn mt-3">Close</button>-->
    </div>

    <Modal :isVisible="showPopup" @close="showPopup = false">
      <h1 v-if="mainSection">Add a new Request Type</h1>
      <h1 v-if="optionsSection">Pick Options</h1>
      <hr>
      <div style="width: 100%; display: flex; justify-content: center; gap: 10px">
<!--        <div style="width: 100%; background-color: orange">Hello</div>-->
        <div v-if="mainSection" style="width: 50%; display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <div class="space-y-4">
            <div>
              <input v-model="name" placeholder="Request type name..." type="text" name="text" class="input">
            </div>

            <div>
              <input type="file" @change="previewImage" class="mt-1 block w-full p-2 border rounded" accept="image/*" style="width: 100%;"/>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Next"
                  @click="activateDepartments"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Close"
                  buttonColor="black"
                  hoverColor="#c82333"
                  hoverTextColor="#ffffff"
                  @click="closeModal"
              />
            </div>


            <!--            <button @click="activateDepartments" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 30px">Next</button>-->
          </div>
        </div>
        <div v-if="allowedDepartmentsSection" style="width: 100%;">
          <div>
            <div class="drag-container">
              <div class="drag-sections">
                <!-- Left Section: List of Items -->
                <div class="left-panel">
                  <h3>Available Departments</h3>
                  <div class="input-group">
                    <input v-model="searchTerm" autocomplete="off" name="Email" id="Email" class="input" type="email" placeholder="Search Department">
                  </div>
                  <hr>
                  <div
                      class="task-list"
                  >
                    <div v-for="(element, index) in filteredDepartments" :key="element.id" class="task-item">
                      <span class="drag-handle">⠿</span>
                      {{ element.name }}
                      <button class="move-btn" @click="moveToRight(element)">➜</button>
                    </div>
                  </div>
                </div>

                <!-- Right Section: Droppable Area -->
                <div class="right-panel">
                  <h3>Selected</h3>
                  <hr>
                  <div
                      class="task-list"
                  >
                    <div v-for="(element, index) in droppedItems" :key="element.id" class="task-item">
                      <span class="drag-handle">⠿</span>
                      {{ element.name }}
                      <button class="move-btn" @click="moveToLeft(element)">X</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Back"
                  @click="activateMain"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Next"
                  @click="activateOptions"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Close"
                  buttonColor="black"
                  hoverColor="#c82333"
                  hoverTextColor="#ffffff"
                  @click="closeModal"
              />
            </div>

<!--            <button @click="activateOptions" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 30px">Next</button>-->
          </div>
        </div>
        <div v-if="optionsSection" style="width: 50%; display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <div class="space-y-4">
            <div class="checkbox-group">
              <div class="d-flex">
                <div class="role-margin">
                  <label><input type="checkbox" v-model="option.hasSupplier"/> Supplier</label>
                  <label><input type="checkbox" v-model="option.hasStore"/> Store</label>
                  <label><input type="checkbox" v-model="option.hasInvoice"/> Invoice</label>
                  <label><input type="checkbox"  v-model="option.hasTicket"/> Tickets</label>
<!--                  <label><input type="checkbox"  v-model="option.showOnHelpDesk"/> Help Desk</label>-->
                  <label><input type="checkbox"  v-model="option.hasImageId"/> Image</label>
                  <label><input type="checkbox"  v-model="option.hasPurchaseOrder"/> PurchaseOrder</label>
                </div>
                <div class="role-margin">
<!--                  <label><input type="checkbox" v-model="option.hasType"/> Type</label>-->
                  <label><input type="checkbox" v-model="option.hasTime"/> Time</label>
                  <label><input type="checkbox" v-model="option.hasJobCardHeaderId"/> JobCard</label>
                  <label><input type="checkbox" v-model="option.hasManagerAuth"/> Manger Approval</label>
                  <label><input type="checkbox" v-model="option.isAsset"/> Assets</label>
                </div>
              </div>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Back"
                  @click="activateDepartments"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Submit"
                  @click="submitRequestType"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Close"
                  buttonColor="black"
                  hoverColor="#c82333"
                  hoverTextColor="#ffffff"
                  @click="closeModal"
              />
            </div>
<!--            <button @click="activateDepartments" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 30px">Back</button>-->
<!--            <button @click="submitRequestType" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 5px">Submit</button>-->
          </div>
        </div>

        <div v-if="allowedDepartmentsSection === false" style="width: 50%;">
          <h3 class="text-lg font-semibold">Preview</h3>
          <div v-if="name || imageUrl" class="mt-4 p-4 border rounded">
            <p v-if="name" class="mt-2">{{ name }}</p>
            <img v-if="imageUrl" :src="imageUrl" alt="Preview" class="mt-2 max-w-full h-auto rounded" />
          </div>
        </div>
      </div>
<!--      <ApproveButton-->
<!--          style="margin-top: 30px"-->
<!--          buttonText="Close"-->
<!--          buttonColor="black"-->
<!--          hoverColor="#c82333"-->
<!--          hoverTextColor="#ffffff"-->
<!--          @click="closeModal"-->
<!--      />-->
    </Modal>
    <Modal :isVisible="showPopup2" @close="showPopup2 = false">
      <h1 v-if="mainSection">Update Request Type - {{ requestTypeName }}</h1>
      <h1 v-if="optionsSection">Pick Options</h1>
      <hr>
      <div style="width: 100%; display: flex; justify-content: center; gap: 10px">
        <div v-if="mainSection" style="width: 50%; display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <div class="space-y-4">
            <div>
              <input v-model="name" placeholder="New name..." type="text" name="text" class="input">
            </div>

            <div>
              <input type="file" @change="previewImage" class="mt-1 block w-full p-2 border rounded" accept="image/*" style="width: 100%;"/>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Next"
                  @click="activateDepartments"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Close"
                  buttonColor="black"
                  hoverColor="#c82333"
                  hoverTextColor="#ffffff"
                  @click="closeUpdateModal"
              />
            </div>

<!--            <button @click="activateOptions" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 30px">Next</button>-->
          </div>
        </div>
        <div v-if="allowedDepartmentsSection" style="width: 100%;">
          <div>
            <div class="drag-container">
              <div class="drag-sections">
                <!-- Left Section: List of Items -->
                <div class="left-panel">
                  <h3>Available Departments</h3>
<!--                  <div class="input-group">-->
<!--                    <input v-model="searchTerm" autocomplete="off" name="Email" id="Email" class="input" type="email" placeholder="Milestone name">-->
<!--                  </div>-->
                  <hr>
                  <div
                      class="task-list"
                  >
                    <div v-for="(element, index) in filteredDept" :key="element.id" class="task-item">
                      <span class="drag-handle">⠿</span>
                      {{ element.name }}
                      <button class="move-btn" @click="moveToRight2(element)">➜</button>
                    </div>
                  </div>
                </div>

                <!-- Right Section: Droppable Area -->
                <div class="right-panel">
                  <h3>Selected</h3>
                  <hr>
                  <div
                      class="task-list"
                  >
                    <div v-for="(element, index) in requestTypeDept" :key="element.id" class="task-item">
                      <span class="drag-handle">⠿</span>
                      {{ element.name }}
                      <button class="move-btn" @click="moveToLeft2(element)">X</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Back"
                  @click="activateMain"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Next"
                  @click="activateOptions"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Close"
                  buttonColor="black"
                  hoverColor="#c82333"
                  hoverTextColor="#ffffff"
                  @click="closeUpdateModal"
              />
            </div>

            <!--            <button @click="activateOptions" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 30px">Next</button>-->
          </div>
        </div>
        <div v-if="optionsSection" style="width: 50%; display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <div class="space-y-4">
            <div class="checkbox-group">
              <div class="d-flex">
                <div class="role-margin">
                  <label><input type="checkbox" v-model="holder.hasSupplier"/> Supplier</label>
                  <label><input type="checkbox" v-model="holder.hasStore"/> Store</label>
                  <label><input type="checkbox" v-model="holder.hasInvoice"/> Invoice</label>
                  <label><input type="checkbox"  v-model="holder.hasTicket"/> Tickets</label>
<!--                  <label><input type="checkbox"  v-model="holder.showOnHelpDesk"/> Help Desk</label>-->
                  <label><input type="checkbox"  v-model="holder.hasImageId"/> Image</label>
                  <label><input type="checkbox"  v-model="holder.hasPurchaseOrder"/> PurchaseOrder</label>
                </div>
                <div class="role-margin">
<!--                  <label><input type="checkbox" v-model="holder.hasType"/> Type</label>-->
                  <label><input type="checkbox" v-model="holder.hasTime"/> Time</label>
                  <label><input type="checkbox" v-model="holder.hasJobCardHeaderId"/> JobCard</label>
                  <label><input type="checkbox" v-model="holder.hasManagerAuth"/> Manger Approval</label>
                  <label><input type="checkbox" v-model="holder.isAsset"/> Assets</label>
                </div>
              </div>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Back"
                  @click="activateDepartments"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Submit"
                  @click="UpdateRequestType"
              />
              <ApproveButton
                  style="margin-top: 20px"
                  buttonText="Close"
                  buttonColor="black"
                  hoverColor="#c82333"
                  hoverTextColor="#ffffff"
                  @click="closeUpdateModal"
              />
            </div>
<!--            <button @click="activateMain" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 30px">Back</button>-->
<!--            <button @click="UpdateRequestType" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 5px">Update</button>-->
          </div>
        </div>

        <div v-if="allowedDepartmentsSection === false" style="width: 50%;">
          <h3 class="text-lg font-semibold">Preview</h3>
          <div v-if="name || imageUrl" class="mt-4 p-4 border rounded">
            <p v-if="name" class="mt-2">{{ name }}</p>
            <img v-if="imageUrl" :src="imageUrl" alt="Preview" class="mt-2 max-w-full h-auto rounded" />
          </div>
        </div>
      </div>
<!--      <ApproveButton-->
<!--          style="margin-top: 30px"-->
<!--          buttonText="Close"-->
<!--          buttonColor="black"-->
<!--          hoverColor="#c82333"-->
<!--          hoverTextColor="#ffffff"-->
<!--          @click="closeUpdateModal"-->
<!--      />-->
    </Modal>
    <Modal :isVisible="showPopup3" @close="showPopup3 = false">
      <h1>Create</h1>
      <h1 v-if="optionsSection">Pick Options</h1>
      <hr>
      <div style="display: flex; width: 100%; gap: 10px">
        <div style="align-items: center; width: 100%;">
          <label for="subtype">REQUEST TYPE</label>
          <select id="subtype" class="form-control" v-model="typeID" @change="pickSubRoute">
            <option v-for="type in allRequestTypes" :key="type.id" :value="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>
        <div v-if="showSubtype === true" style="align-items: center; width: 100%;">
          <label for="subtype">EXPENSE ACCOUNT</label>
          <select id="subtype" class="form-control" v-model="chartID">
            <option v-for="chart in charts" :key="chart.chart_id" :value="chart.chart_id">
              {{ chart.chartName }}
            </option>
          </select>
        </div>
      </div>
      <div style="width: 100%;">
        <input v-model="subTypeName" placeholder="Sub type name..." type="text" name="text" class="input" style="width: 100%; margin-top: 15px" />
      </div>
      <div style="display: flex;">
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Submit"
            buttonColor="black"
            @click="submitSubType"
        />
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Close"
            buttonColor="black"
            hoverColor="#c82333"
            hoverTextColor="#ffffff"
            @click="closeSubTypeModal"
        />
      </div>
    </Modal>
    <Modal :isVisible="showPopup4" @close="showPopup4 = false">
      <div style="width: 100%; display: flex; justify-content: center; gap: 10px">
        <div v-if="mainSection" style="width: 50%; display: flex; flex-direction: column;">
          <h1>Subtypes</h1>
          <div>
            <div
                v-for="(sub, index) in subTypeByID"
                :key="index"
            >
              <div class="subss">
                <h5>{{ index + 1 }}. {{ sub.name }}</h5>
                <button class="Btn" @click="updateSubType(sub)">
                  Edit
                  <svg class="svg" viewBox="0 0 512 512">
                    <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"></path></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 50%;">
          <h1 class="text-lg font-semibold">Edit</h1>
          <div v-if="optionsSection" style="margin-top: 30px">
            <div>
              <input v-model="subTypeName" placeholder="Request type name..." type="text" name="text" class="input">
            </div>
            <div style="display: flex; flex-direction: column; width: 100%; gap: 10px">
              <div style="align-items: center; width: 100%;">
                <label for="subtype">REQUEST TYPE</label>
                <select id="subtype" class="form-control" v-model="typeID" @change="pickSubRoute">
                  <option v-for="type in allRequestTypes" :key="type.id" :value="type.id">
                    {{ type.name }}
                  </option>
                </select>
              </div>
              <div style="align-items: center; width: 100%;">
                <label for="subtype">EXPENSE ACCOUNT</label>
                <select v-if="showSubtype === true" id="subtype" class="form-control" v-model="chartID">
                  <option v-for="chart in charts" :key="chart.chart_id" :value="chart.chart_id">
                    {{ chart.chartName }}
                  </option>
                </select>
              </div>
            </div>
            <button @click="submitUpdateSubType" type="submit" class="bg-blue-500 text-white px-4 py-2 rounded" style="background-color: #1d90dd; color: white; width: 100%; margin-top: 30px">Update</button>
          </div>
        </div>
      </div>
      <div style="display: flex;">
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Add a Subtype"
            @click="addNewSubtype"
        />
        <ApproveButton
            style="margin-top: 30px"
            buttonText="Close"
            buttonColor="black"
            hoverColor="#c82333"
            hoverTextColor="#ffffff"
            @click="closeSubModal"
        />
      </div>
    </Modal>
  </div>
</template>

<script>
// import CustomModal from "@/components/layout/CustomModal.vue";
import axios from "axios";
import Modal from "@/components/PopUpModal.vue"
import ApproveButton from "@/components/buttons/ApproveButton.vue";
import {Storage} from "@/Services/Storage";
import Swal from "sweetalert2";
import SessionSetup from "@/components/SessionSetup.vue";

export default {
  components: {
    ApproveButton,
    Modal,
    SessionSetup,
  },
  data() {
    return {
      isManager: false,
      showSubtype: false,
      requestTypeDept: [],
      searchTerm: '',
      droppedItems: [],
      allDepartments: [],
      userDept: null,
      user: null,
      isImage: false,
      holderID: null,
      subTypeByID: [],
      typeID: null,
      subTypeName: null,
      charts: [],
      chartID: null,
      subTypes: null,
      sessionSetup: null,
      holder: {
        hasSupplier: false,
        hasStore: false,
        hasInvoice: false,
        hasTicket: false,
        // hasWallet: false,
        hasImageId: false,
        hasPurchaseOrder: false,
        hasType: false,
        hasTime: false,
        hasJobCardHeaderId: false,
        hasManagerAuth: false,
        isAsset: false,
      },
      option: {
        hasSupplier: false,
        hasStore: false,
        hasInvoice: false,
        hasTicket: false,
        // hasWallet: false,
        hasImageId: false,
        hasPurchaseOrder: false,
        hasType: false,
        hasTime: false,
        hasJobCardHeaderId: false,
        hasManagerAuth: false,
        isAsset: false,
      },
      mainSection: true,
      allowedDepartmentsSection: false,
      optionsSection: false,
      requestTypeName: '',
      requestTypeID: null,
      showPopup: false,
      showPopup2: false,
      showPopup3: false,
      showPopup4: false,
      name: '',
      imageUrl: null,
      imageBase64: null,
      tagForm: null,
      activeRole: null,
      selectedOption: null,
      showSalesTarget: false,
      tags: false,
      requestsTypes: null,
      activeRolePermissions: null,
      options2: [
        {
          label: "User Permissions",
          description: "Manage access roles.",
          icon: "UserIcon", // You can replace this with actual SVG or component
        },
        {
          label: "Edit Name",
          description: "Change the project or user name.",
          icon: "EditIcon",
        },
        {
          label: "New Deployment",
          description: "Initiate a new deployment process.",
          icon: "CloudDownloadIcon",
        },
        {
          label: "Analytics",
          description: "View project analytics and reports.",
          icon: "ChartIcon",
        },
        {
          label: "Request Types",
          description: "Adjust your project settings and preferences.",
          icon: "SettingsIcon",
        },
      ],
      allRequestTypes: [],
      salesTarget: [],
      // targetForm: {
      //   year: "",
      //   targetPerMonth: "",
      //   minimumTarget: "",
      //   hardwarePercentage: "",
      //   consumablePercentage: "",
      //   hardwareComsPercentage: "",
      //   softwareComsPercentage: ""
      // },
      // targetEdit: {
      //   year: "",
      //   targetPerMonth: "",
      //   minimumTarget: "",
      //   hardwarePercentage: "",
      //   consumablePercentage: "",
      //   hardwareComsPercentage: "",
      //   softwareComsPercentage: ""
      // }
    };
  },
  created() {
    // this.getRoles();
    this.getLoggedInUser();
    this.checkIsManger();
  },
  computed: {
    filteredDept() {
      return this.allDepartments.filter(bItem => !this.requestTypeDept.some(aItem => aItem.id === bItem.id));
    },
    filteredDepartments() {
      return this.allDepartments.filter((item) =>
          item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
    pickedDepartments() {
      return this.droppedItems.map(item => item.id);
    },
    pickedDepartments2() {
      return this.requestTypeDept.map(item => item.id);
    },
    curUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    async checkIsManger() {
      // GINGER-20260710-USERID-GUARD-FIX: same defense as NavigationDrawer.vue — skip when
      // curUser is null/undefined to prevent Spring 400 from the manager check.
      if (!this.curUser || this.curUser.id == null) return;
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + `isuserManager?userid=${this.curUser.id}`);
        this.isManager = response.data;
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        // this.checker()
        this.$utils.hideLoading();
      }
    },
    check() {
      console.log('this is the result', this.filteredDept)
      console.log('All arrays', this.allDepartments)
      console.log('Partial', this.requestTypeDept)
    },
    pickSubRoute() {
      const selected = this.allRequestTypes.find(type => type.id === this.typeID);
      if (selected && selected.options.isAsset === true) {
        console.log('Selected type:', selected);
        this.getCharts2();
      } else {
        this.getCharts();
      }
    },
    moveToRight(item) {
      this.droppedItems.push(item);
      this.allDepartments = this.allDepartments.filter(dept => dept.id !== item.id);
    },
    moveToLeft(item) {
      this.allDepartments.push(item);
      this.droppedItems = this.droppedItems.filter(dept => dept.id !== item.id);
    },
    moveToRight2(item) {
      this.requestTypeDept.push(item);
      this.filteredDept = this.filteredDept.filter(dept => dept.id !== item.id);
    },
    moveToLeft2(item) {
      this.filteredDept.push(item);
      this.requestTypeDept = this.requestTypeDept.filter(dept => dept.id !== item.id);
    },
    async getLoggedInUser() {
      this.user = await Storage.getCurrentUser();
      await this.getUserDept();
      console.log(this.user);
    },
    async getUserDept() {
      // this.$utils.showLoading()
      try {
        const response = await axios.get(`${synergyApi}employee/department-by-username/${this.user.username}`);
        this.userDept = response.data;
        await this.getRoles();
        // console.log(this.userDept);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        // this.$utils.hideLoading();
      }
    },
    async getRequestTypeDept(role) {
      // this.$utils.showLoading()
      try {
        const response = await axios.get(`${ticketApi2}getDepartmentsByRequestType?requestId=${role.id}`);
        this.requestTypeDept = response.data;
        await this.getAllDepartments();
        console.log(this.requestTypeDept);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        // this.$utils.hideLoading();
      }
    },
    async getAllDepartments() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(`${synergyApi}employee/getAllDepartments`);
        this.allDepartments = response.data;
        // console.log(this.userDept);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    updateSubType(sub) {
      console.log(sub);
      this.subTypeName = sub.name;
      this.typeID = sub.requestTypeId;
      this.chartID = sub.chartId;
      this.holderID = sub.id;
      this.optionsSection = true;
    },
    async submitUpdateSubType() {
      if ((this.subTypeName === null || this.subTypeName === "") || this.chartID === null || this.typeID === null) {
        await Swal.fire({
          title: "warning!",
          text: "Some fields are missing, please fill in all fields and try again.",
          icon: "warning",
          confirmButtonText: "OK"
        });
      } else {
        this.$utils.showLoading();
        try {
          const payload = {
            name: this.subTypeName,
            requestTypeId: this.typeID,
            chartId: this.chartID,
          };
          console.log(payload);
          this.$utils.showLoading();
          const response = await axios.put(`${ticketApi2}requests/subcategories/${this.holderID}`, payload);
          await Swal.fire({
            title: "Success!",
            text: "Updated successfully.",
            icon: "success",
            confirmButtonText: "OK"
          })
          this.showSubtype = false;
        } catch (error) {
          await errorHandler.tomcatError(error);
        } finally {
          this.$utils.hideLoading();
          this.closeSubModal();
        }
      }
    },
    async getCharts() {
      console.log('first route')
      // this.loading = true;
      this.$utils.showLoading()
      try {
        const response = await axios.get(`${backOfficeApi}expenseAccounts/burntofi_chrilan/getAll?archived=false`);
        this.charts = response.data;
        this.showSubtype = true;
        console.log(this.charts);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        // this.loading = false;
        this.$utils.hideLoading();
      }
    },
    async getCharts2() {
      console.log('second route')
      // this.loading = true;
      this.$utils.showLoading()
      try {
        const response = await axios.get(`${backOfficeApi}assets/burntofi_chrilan/getAll?archived=false`);
        this.charts = response.data;
        this.showSubtype = true;
        console.log(this.charts);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        // this.loading = false;
        this.$utils.hideLoading();
      }
    },
    async getSubTypeByID(sub) {
      this.$utils.showLoading()
      try {
        const response = await axios.get(`${ticketApi2}requests/types/${sub.id}/subcategories`);
        this.subTypeByID = response.data;
        console.log(this.subTypeByID);
        this.showPopup4 = true;
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    activateMain() {
      this.allowedDepartmentsSection = false;
      this.optionsSection = false;
      this.mainSection = true;
    },
    activateDepartments() {
      this.mainSection = false;
      this.optionsSection = false;
      this.allowedDepartmentsSection = true;
      this.getAllDepartments();
    },
    activateOptions() {
      this.mainSection = false;
      this.allowedDepartmentsSection = false;
      this.optionsSection = true;
    },
    showModal() {
      this.showPopup = true;
    },
    closeModal() {
      this.isImage = false;
      this.imageUrl = null;
      this.name = null;
      this.showPopup = false;
      this.holder = {};
      this.allowedDepartmentsSection = false;
      this.optionsSection = false;
      this.mainSection = true;
    },
    updateModal(role) {
      this.getRequestTypeDept(role);
      this.holder = { ...role.options };
      console.log(this.holder);
      this.requestTypeID = role.id;
      this.requestTypeName = role.name;
      this.showPopup2 = true;
    },
    viewSubType(type) {
      console.log(type)
      this.typeID = type.id;
      this.getSubTypeByID(type);
    },
    closeSubModal() {
      this.subTypeName = null;
      this.typeID = null;
      this.chartID = null;
      this.holderID = null;
      this.optionsSection = false;
      this.showPopup4 = false;
      this.showSubtype = false;
    },
    closeUpdateModal() {
      this.showPopup2 = false;
      this.holder = {};
      this.allowedDepartmentsSection = false;
      this.optionsSection = false;
      this.mainSection = true;
    },
    addNewSubtype() {
      this.showPopup4 = false;
      this.pickSubRoute();
      this.showPopup3 = true;
    },
    SubTypeModal() {
      this.showPopup3 = true;
    },
    closeSubTypeModal() {
      this.subTypeName = null;
      this.typeID = null;
      this.chartID = null;
      this.showPopup3 = false;
      this.showSubtype = false;
    },
    previewImage(event) {
      this.isImage = true;
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    // submitForm() {
    //   alert(`Name: ${this.name}\nImage selected: ${this.imageUrl ? 'Yes' : 'No'}`);
    // },
    // async createTag(item){
    //   this.tagForm = {...item};
    //   return Swal.fire({
    //     title: "Enter Tag Description",
    //     input: "text",
    //     icon: "icon",
    //     showCancelButton: true,
    //     background: '#fff',
    //     color: '#000',
    //     confirmButtonText: "Submit",
    //     showLoaderOnConfirm: true,
    //     preConfirm: async (input) => {
    //       const url = `${synergyApi}tags`
    //       const payload = {
    //         description: input,
    //         typeId: this.tagForm.id,
    //       }
    //       return this.$store.dispatch('sendRequest', {url,payload})
    //           .then(() => {
    //             this.fetchTypes();
    //             responses.showSuccess('Tag Created Successfully.');
    //           })
    //     },
    //     allowOutsideClick: () => !Swal.isLoading()
    //   })
    // },
    // async createTypes(){
    //   return Swal.fire({
    //     title: "Enter Ticket Type",
    //     input: "text",
    //     icon: "icon",
    //     showCancelButton: true,
    //     background: '#fff',
    //     color: '#000',
    //     confirmButtonText: "Submit",
    //     showLoaderOnConfirm: true,
    //     preConfirm: async (input) => {
    //       const url = `${synergy4}types`
    //       const payload = {
    //         name: input,
    //       }
    //       return this.$store.dispatch('sendRequest', {url,payload})
    //           .then(() => {
    //             this.fetchTypes();
    //             responses.showSuccess('Type Created Successfully.');
    //           })
    //     },
    //     allowOutsideClick: () => !Swal.isLoading()
    //   })
    // },
    // async editSalesTarget(){
    //   this.$store.commit('setLoadingState', true);
    //   return await this.$store.dispatch('editSalesTarget', this.targetEdit)
    //       .then(() => {
    //         this.resetEditForm();
    //         this.fetchSaleTarget();
    //         responses.showSuccess(`Sales Target successfully edited.`);
    //       })
    //       .finally(()=> this.$store.commit('setLoadingState', false));
    // },
    // resetEditForm(){
    //   this.targetEdit = {
    //     year: "",
    //     targetPerMonth: "",
    //     minimumTarget: "",
    //     hardwarePercentage: "",
    //     consumablePercentage: "",
    //     hardwareComsPercentage: "",
    //     softwareComsPercentage: ""
    //   }
    // },
    // openEditModel(item){
    //   this.targetEdit = {...item};
    //   this.$refs.editTarget.openModal();
    // },
    // async fetchSaleTarget() {
    //   this.$store.commit('setLoadingState', true);
    //   return this.$store.dispatch('getSalesTargets')
    //       .then(response => {
    //         this.salesTarget = response;
    //       })
    //       .finally(() => this.$store.commit('setLoadingState', false));
    // },
    // async fetchTypes() {
    //   this.$store.commit('setLoadingState', true);
    //   return this.$store.dispatch('getTicketTypes')
    //       .then(response => {
    //         this.tags = response;
    //       })
    //       .finally(() => this.$store.commit('setLoadingState', false));
    // },
    // getManager(targetAmount) {
    //   // Implement logic to get manager name based on target amount if needed
    //   return "Manager Name"; // Placeholder
    // },
    // showSalesTargetPanel() {
    //   this.selectedOption = null;
    //   this.showSalesTarget = true;
    //   this.tags = false;
    //   this.fetchSaleTarget();
    // },
    // showTypes() {
    //   this.selectedOption = null;
    //   this.showSalesTarget = false;
    //   this.tags = true;
    //   this.fetchTypes();
    // },
    showRequestTypes() {
      this.selectedOption = null;
      this.sessionSetup = false;
      this.subTypes = false;
      this.requestsTypes = true;
    },
    showSubTypes() {
      this.selectedOption = null;
      this.sessionSetup = false;
      this.requestsTypes = false;
      this.subTypes = true;
    },
    showSessionSetup() {
      this.selectedOption = null;
      this.requestsTypes = false;
      this.subTypes = false;
      this.sessionSetup = true;
    },
    // selectOptionAndHideSalesTarget(item) {
    //   this.selectedOption = item;
    //   this.showSalesTarget = false;
    // },
    // async getPermissions() {
    //   try {
    //     const url = synergy4 + `employee/GetUserRoles/${this.curUser.id}`;
    //     const response = await axios.get(url);
    //     const access = response.data;
    //     console.log(access);
    //     await this.$store.dispatch("setPermissions", access);
    //   } catch (error) {
    //     await errorHandler.tomcatError(error);
    //   }
    // },
    // openCreateTarget() {
    //   this.$refs.createTarget.openModal();
    // },
    // async createTarget() {
    //   this.$store.commit('setLoadingState', true);
    //   return await this.$store.dispatch('createTarget', this.targetForm)
    //       .then(() => {
    //         this.resetTargetForm();
    //         responses.showSuccess("Successfully created target!");
    //         this.fetchSaleTarget(); // Refresh the list after creating
    //       })
    //       .finally(() => this.$store.commit('setLoadingState', false));
    // },
    // resetTargetForm() {
    //   this.targetForm = {
    //     year: "",
    //     targetPerMonth: "",
    //     minimumTarget: "",
    //     hardwarePercentage: "",
    //     consumablePercentage: "",
    //     hardwareComsPercentage: "",
    //     softwareComsPercentage: ""
    //   }
    // },
    closeContent() {
      this.selectedOption = null;
      this.showSalesTarget = false;
      this.activeRole = null;
      this.requestsTypes = null;
      this.subTypes = false;
      this.sessionSetup = false;
    },
    // openRolePermissions(role) {
    //   this.activeRole = role;
    //   this.activeRolePermissions = {
    //     id: role.id,
    //     roleName: role.roleName,
    //     kyc: role.kyc || false,
    //     booking: role.booking || false,
    //     stockHandling: role.stockHandling || false,
    //     warningReports: role.warningReports || false,
    //     staffManagement: role.staffManagement || false,
    //     support: role.support || false,
    //     lytsiSignSmartInvoiceUps: role.lytsiSignSmartInvoiceUps || false,
    //     customerInfo: role.customerInfo || false,
    //     sales: role.sales || false,
    //     kazangPosSignInvoiceUps: role.kazangPosSignInvoiceUps || false,
    //     roleManagement: role.roleManagement || false,
    //     scheduling: role.scheduling || false,
    //     settings: role.settings || false,
    //     salesOpportunities: role.salesOpportunities || false,
    //     viewLeaveRequests: role.viewLeaveRequests || false,
    //     viewDisciplinaryActions: role.viewDisciplinaryActions || false,
    //     smartInvoiceReports: role.smartInvoiceReports || false,
    //     salesReports: role.salesReports || false,
    //     authorizeLeave: role.authorizeLeave || false,
    //     salesTargetsSetup: role.salesTargetsSetup || false,
    //     supportStatistics: role.supportStatistics || false,
    //     supportReports: role.supportReports || false,
    //     projectManagement: role.projectManagement || false,
    //     operationsSetup: role.operationsSetup || false,
    //     leads: role.leads || false,
    //     officeReports: role.officeReports || false,
    //     developerDashboard: role.developerDashboard || false,
    //     lytSoftSignInvoiceUps: role.lytSoftSignInvoiceUps || false,
    //     proposals: role.proposals || false,
    //     smartInvoicing: role.smartInvoicing || false,
    //   };
    // },
    closeRolePopup() {
      this.activeRole = null;
    },
    async getRoles() {
      this.$utils.showLoading()
      try {
        const response = await axios.get(`${ticketApi2}requests/requestTypes`);
        this.allRequestTypes = response.data;
        console.log(this.allRequestTypes);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    async submitSubType() {
      if ((this.subTypeName === null || this.subTypeName === "") || this.chartID === null || this.typeID === null) {
        return await Swal.fire({
          title: "warning!",
          text: "Some fields are missing, please fill in all fields and try again.",
          icon: "warning",
          confirmButtonText: "OK"
        });
      } else {
        this.$utils.showLoading();
        try {
          const payload = {
            name: this.subTypeName,
            requestTypeId: this.typeID,
            chartId: this.chartID,
          };
          console.log(payload);
          this.$utils.showLoading();
          const response = await axios.post(`${ticketApi2}requests/create_subcategories`, payload);
          await Swal.fire({
            title: "Success!",
            text: "Submitted successfully.",
            icon: "success",
            confirmButtonText: "OK"
          })
          this.showSubtype = false;
        } catch (error) {
          await errorHandler.tomcatError(error);
        } finally {
          this.$utils.hideLoading();
          this.closeSubTypeModal();
        }
      }
    },
    async submitRequestType() {
      console.log("Base64 Image:", this.imageBase64);
      let payload;
      if (this.name === null || this.name === "" || this.isImage === false) {
        return await Swal.fire({
          title: "warning!",
          text: "Some fields are missing, please fill in all fields and try again.",
          icon: "warning",
          confirmButtonText: "OK"
        });
      } else {
        if (this.droppedItems.length > 0) {
          payload = {
            name: this.name,
            image: this.imageBase64,
            departmentIds: this.pickedDepartments,
            options: this.option,
          };
        } else {
          payload = {
            name: this.name,
            image: this.imageBase64,
            departmentIds: [0],
            options: this.option,
          };
        }
        try {
          console.log(payload);
          this.$utils.showLoading();
          const response = await axios.post(`${ticketApi2}requests/create_request_types`, payload);
          await Swal.fire({
            title: "Success!",
            text: "Submitted successfully.",
            icon: "success",
            confirmButtonText: "OK"
          });
          await this.getRoles();
        } catch (error) {
          await errorHandler.tomcatError(error);
        } finally {
          this.$utils.hideLoading();
          this.name = null;
          this.imageBase64 = null;
          this.droppedItems = [];
          this.option = null;
          this.closeModal();
        }
      }
    },
    async UpdateRequestType() {
      console.log("Base64 Image:", this.imageBase64);
      let payload;
      if (this.requestTypeDept.length > 0) {
        payload = {
          name: this.name,
          image: this.imageBase64,
          departmentIds: this.pickedDepartments2,
          options: this.holder,
        };
      } else {
        payload = {
          name: this.name,
          image: this.imageBase64,
          departmentIds: [0],
          options: this.holder,
        };
      }
      try {
        console.log(payload);
        this.$utils.showLoading();
        const response = await axios.put(`${ticketApi2}requests/types/${this.requestTypeID}`, payload);
        await Swal.fire({
          title: "Success!",
          text: "Updated successfully.",
          icon: "success",
          confirmButtonText: "OK"
        });
        this.holder = {};
        await this.getRoles();
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
        this.closeUpdateModal();
      }
    }
  },
};
</script>

<style scoped>

.d-flex {
  display: flex;
}
.role-margin {
  margin: 10px;
}

.settings-container {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

/* Left Card */
.card {
  width: 100%;
  max-width: 400px;
  background: #f9f9f9;
  padding: 20px;
  padding-top: 40px;
  transition: transform 0.3s ease;
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;
}

/* Slide out card when active */
.card.active {
  transform: translateX(-100%);
}

/* List styles */
.list {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.item {
  display: flex;
  gap: 30px;
  align-items: center;
  padding: 5px;
  margin: 5px 0;
  background: aliceblue;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
  font-weight: 600;
  letter-spacing: 2px;
}

.item:hover {
  background: #e6e6e6;
}

/* Right content */
.content {
  flex: 1;
  padding: 20px;
  background: #ffffff;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  box-sizing: border-box;
  z-index: 10;
}



/* Icon size */
.icon {
  width: 22px;
  height: 22px;
}

/* Desktop view (large screens) */
@media (min-width: 768px) {
  .settings-container {
    flex-direction: row;
  }

  .card {
    transform: translateX(0);
    position: relative;
  }

  .card.active {
    transform: translateX(0); /* Prevent slide on desktop */
  }

  .content {
    position: relative;
    transform: none;
    top: 0;
    left: 0;
    width: calc(100% - 400px);
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
  }
}

.role-card {
  width: 100%;
  height: 50px;
  padding: 10px;
  background-color: aliceblue;
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.role-card:hover {
  background-color: lightgray;
  transform: scale(1.0);
  cursor: pointer;
}

.p-tag {
  font-weight: 200;
  font-size: 15px;
  letter-spacing: 2px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
}

.checkbox-group {
  height: fit-content;
  overflow-y: auto;
}

.checkbox-group label {
  display: block;
  margin: 10px 0;
}



@media (max-width: 767px) {
  .modal-content {
    height: 98%;
  }
  .content {
    flex: 1;
    padding: 20px;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 90%;
    overflow: auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    box-sizing: border-box;
    z-index: 10;
  }
  .d-flex {
    display: flex;
    flex-direction: column;
  }
}
img {
  width: 100px;
  height: 100px;
}

.input {
  width: 100%;
  height: 45px;
  padding: 12px;
  border-radius: 5px;
  border: 1.5px solid lightgrey;
  outline: none;
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  box-shadow: 0px 0px 20px -18px;
}

.input:hover {
  border: 2px solid lightgrey;
  box-shadow: 0px 0px 20px -17px;
}

.input:active {
  transform: scale(0.95);
}

.input:focus {
  border: 2px solid grey;
}

.Btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 90px;
  height: 40px;
  border: none;
  padding: 0px 20px;
  background-color: #1d90dd;
  color: white;
  font-weight: 500;
  cursor: pointer;
  border-radius: 5px;
  transition-duration: .3s;
}

.svg {
  width: 13px;
  position: absolute;
  right: 0;
  margin-right: 20px;
  fill: white;
  transition-duration: .3s;
}

.Btn:hover {
  color: transparent;
}

.Btn:hover svg {
  right: 43%;
  margin: 0;
  padding: 0;
  border: none;
  transition-duration: .3s;
}

.Btn:active {
  transform: translate(3px , 3px);
  transition-duration: .3s;
  box-shadow: 2px 2px 0px rgb(140, 32, 212);
}
.subss {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0;
  padding: 10px;
  background-color: aliceblue;
}


.drag-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 15px;
}

.drag-sections {
  width: 100%;
  display: flex;
  gap: 5px;
}

.left-panel, .right-panel {
  width: 50%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 400px;
  overflow-y: auto;
}

.task-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  margin-bottom: 5px;
  background: #f8f8f8;
  border: 1px solid #ddd;
  cursor: grab;
}

.drag-handle {
  margin-right: 10px;
  cursor: grab;
}

.move-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
}

.move-btn:hover {
  background: #0056b3;
}

</style>
